import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/destructuring-assignment */ import { components as RsComponents, defaultTheme } from 'react-select';
import styled from 'styled-components';
import { UserTag } from './select';
export const StyledDropdownIndicator = styled(RsComponents.DropdownIndicator).attrs({
    theme: {
        ...defaultTheme
    }
})``;
export const DropdownIndicator = (props)=>/*#__PURE__*/ _jsx(StyledDropdownIndicator, {
        ...props
    });
export const StyledControl = styled(RsComponents.Control).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
export const Control = (props)=>/*#__PURE__*/ _jsx(StyledControl, {
        ...props
    });
export const ClearIndicator = (props)=>/*#__PURE__*/ _jsx(RsComponents.ClearIndicator, {
        ...props
    });
export const StyledMultiValue = styled(RsComponents.MultiValue).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
export const SingleUserValue = ({ data, ...props })=>/*#__PURE__*/ _jsx(RsComponents.SingleValue, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            ...data
        })
    });
export const MultiValue = (props)=>/*#__PURE__*/ _jsx(StyledMultiValue, {
        ...props
    });
export const StyledMultiValueLabel = styled(RsComponents.MultiValueLabel).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
export const MultiValueLabel = (props)=>/*#__PURE__*/ _jsx(StyledMultiValueLabel, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            ...props.data
        })
    });
export const StyledMultiValueRemove = styled(RsComponents.MultiValueRemove).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
export const MultiValueRemove = ({ data, ...props })=>/*#__PURE__*/ _jsx(StyledMultiValueRemove, {
        ...props
    });
export const AvatarOption = (props)=>/*#__PURE__*/ _jsx(RsComponents.Option, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            ...props.data
        })
    });
export const TagOption = (props)=>/*#__PURE__*/ _jsx(RsComponents.Option, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            ...props.data
        })
    });
export const TagSingleValue = (props)=>/*#__PURE__*/ _jsx(RsComponents.SingleValue, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            ...props.data
        })
    });
